export default __webpack_public_path__ + "static/media/hashnode.a6de1e75.png";